import { observable, action, runInAction, computed, makeObservable } from "mobx";
import { UploadedTmpFile, fileUploadStore } from "./FileUploadStore";
import { CoreStore, handleStoreState } from "Stores/RESTStore/CoreStore";
import { API_URL } from "General/APIEndpoints";
import { projectsDataStore } from "Stores";
import { documentsTableStore } from "../Stores/DocumentsTableStore";
import { API } from "General/API";

export class ReplaceFileStore extends CoreStore {
  isVisible = false;
  file: UploadedTmpFile;
  data: API_FileDataEntity[] = [];

  constructor() {
    super();

    makeObservable(this, {
      isVisible: observable,
      file: observable,
      data: observable,
      clear: action.bound,
      hideModal: action.bound,
      initModal: action.bound,
      existingFileId: computed,
      fetch: action.bound,
    });
  }

  url(id?: number) {
    const folderId = id || documentsTableStore.currentFolderId;
    return API_URL.DOCUMENTS.getDocumentsByFolderId(projectsDataStore.projectId, folderId);
  }

  clear() {
    this.isVisible = false;
    this.file = undefined;
    this.data = [];
  }

  hideModal() {
    this.isVisible = false;
    this.file = undefined;
  }

  @handleStoreState()
  async fetch(id?: number) {
    try {
      const response: API_MultiDocumentResponse = await API.getData(this.url(id));
      runInAction(() => {
        this.data = (response.items.files || []).filter((i) => i.state === "ACTIVE");
      });
    } catch (error) {
      throw error;
    }
  }

  initModal(file: UploadedTmpFile, refetchFolder = false) {
    this.isVisible = true;
    this.file = file;
    const folderId = refetchFolder ? file.dirid : undefined;
    if (fileUploadStore.module === "WORKFLOW") {
      this.data = fileUploadStore.WFfilesToReplace.slice();
    } else {
      this.fetch(folderId);
    }
  }

  get existingFileId() {
    return this.file && this.file.errors && this.file.errors.existingFile && this.file.errors.existingFile.id;
  }
}

export const replaceFileStore = new ReplaceFileStore();
